module.exports = __webpack_public_path__ + "static/media/1 5 tattoo leg skeleton extended archer eagle.1280x1707.56482de8.webp";